import { createBlocksModel } from '@wix/yoshi-flow-editor/blocks';

export default createBlocksModel({
  widgetName: 'Post Writer',
  props: {},
  methods: {},
  events: {},
});
